import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { HrmRequestFormResponse } from '@Types/api/form';
import { TypeDict } from '@Types/index';
import { parseDateTime } from '@Utils/transformDateTime';

const fieldSource = (
  data: HrmRequestFormResponse,
  findLeaveType: (requestTypeID: number) => TypeDict | undefined
): Array<{ label: string; value: string | number | boolean }> => {
  const { leaveTypeID, startDate, endDate, totDays, remarks, reqStatusId } =
    data;

  const source = {
    Status: reqStatusId,
    Purpose: findLeaveType(leaveTypeID)?.codeDesc || '',
    Remarks: remarks || EMPTY_FIELD_PLACEHOLDER,
    'Required From Date': parseDateTime(startDate, 'DD/MM/YYYY'),
    'Return Date': parseDateTime(endDate, 'DD/MM/YYYY'),
    'Total No. of Days': totDays,
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export default fieldSource;
